import CryptoJs from 'crypto-js'
const OSS = require('ali-oss');
import {  createCRC64 } from "hash-wasm";
import SparkMD5 from 'spark-md5';
let ossClient
let ossAbortMultipartUploadObj = {} // 此对象为了取消固化做的准备
export const ossMultipartUpload = ({ fileHash, accessKey, secretKey, secretToken, bucket, key, file, contentMd5 }, progressCallback) => {
    return new Promise( async (resolve, reject) => {
        ossAbortMultipartUploadObj.size = 0
        ossAbortMultipartUploadObj.key = ''
        ossAbortMultipartUploadObj.uploadId = ''
        try {
            let ossConfig = {
                region: 'oss-cn-beijing', // 这里需要接口传递
                accessKeyId: accessKey,
                accessKeySecret: secretKey,
                stsToken: secretToken,
                bucket: bucket,
                secure: true // 开启https
            }
            // const localCRC64 = await calculateLocalCRC64(file);
            ossClient = new OSS(ossConfig)
            // console.log(contentMd5)
            // let result = await ossClient.put(key, file)
            ossAbortMultipartUploadObj.size = file.size
            ossAbortMultipartUploadObj.key = key
            let result = await ossClient.multipartUpload(key, file, {
                parallel: 4,
                partSize: 1 * 1024 * 1024,
                disabledMD5: false,//开启分片校验文件完整性
                meta: {
                    // 'key': key,
                },
                // headers: {
                //     // 'key': '12345678',
                //     // 'Content-MD5': contentMd5
                // },
                progress: function (p, checkpoint, res) {
                    let percentage = (p * 100).toFixed(0)
                    if (p < 1) {
                        ossAbortMultipartUploadObj.uploadId = checkpoint.uploadId
                    }
                    progressCallback && progressCallback({
                        percentage: parseInt(percentage),
                        ossClient
                    })
                },
                
            })
            // console.log(await ossClient.head(key))
            // CryptoJs.enc.Base64.stringify(md5) === contentMd5
            // console.log(result)
            ossAbortMultipartUploadObj = {}
            //上传完成后，获取服务器端文件的元信息
            // const headResult = await ossClient.head(key)
            // const serverCRC64 = headResult.res.headers['x-oss-hash-crc64ecma']; 
            //比对上传前和上传后的文件的元信息
            // if (localCRC64 === serverCRC64) {
            //     resolve({})
            // } else {
            //     reject({code :'InvalidDigest', localCRC64})
            // }
            resolve({})
        } catch (error) {
            reject(error)
        }
        
    })
}

//对每个分片md5校验文件完整性
export const ossMultipartUploadMD5 = ({ fileHash, accessKey, secretKey, secretToken, bucket, key, file, contentMd5 }, progressCallback) => {
    return new Promise( async (resolve, reject) => {
        // 初始化上传状态对象
        ossAbortMultipartUploadObj.size = 0
        ossAbortMultipartUploadObj.key = ''
        ossAbortMultipartUploadObj.uploadId = ''

        let ossConfig = {
            region: 'oss-cn-beijing', // 这里需要接口传递
            accessKeyId: accessKey,
            accessKeySecret: secretKey,
            stsToken: secretToken,
            bucket: bucket,
            secure: true // 开启https
        }
        
        // 保存配置信息，用于取消上传时使用
        ossAbortMultipartUploadObj.ossConfig = ossConfig
        
        try {
            const localOssClient = new OSS(ossConfig)
            // 保存全局客户端引用，用于取消上传
            ossClient = localOssClient
            ossAbortMultipartUploadObj.size = file.size
            ossAbortMultipartUploadObj.key = key
            
            // 1. 初始化分片上传，获取uploadId
            const { uploadId } = await localOssClient.initMultipartUpload(key)
            ossAbortMultipartUploadObj.uploadId = uploadId
            
            // 2. 分割文件并计算每个分片的MD5
            const chunks = await splitFileAndCalculateMd5(file, 10 * 1024 * 1024)
            console.log('分片完成，开始上传')
            // 3. 并发上传所有分片，每个分片携带自己的MD5
            let uploadedSize = 0
            let lastProgress = 0
            const uploadPromises = []
            
            // 限制并发上传数量，避免过多并发导致异常
            const maxConcurrent = 4
            for (let i = 0; i < chunks.length; i += maxConcurrent) {
                // 检查是否已被取消
                if (!ossAbortMultipartUploadObj.uploadId) {
                    throw new Error('上传已被取消')
                }
                const chunkBatch = chunks.slice(i, i + maxConcurrent)
                const batchPromises = chunkBatch.map(async (chunk, index) => {
                    const actualIndex = i + index
                    return new Promise(async (resolve, reject) => {
                        try {
                            // 检查是否已被取消
                            if (!ossAbortMultipartUploadObj.uploadId) {
                                reject(new Error('上传已被取消'))
                                return
                            }
                            
                            const result = await localOssClient.uploadPart(
                                key,
                                uploadId,
                                actualIndex + 1, // 分片编号从1开始
                                chunk.blob, // 分片二进制数据
                                {
                                    headers: {
                                        // 标准HTTP Content-MD5头，OSS会自动校验分片完整性
                                        'Content-MD5': chunk.md5Base64,
                                    },
                                    progress: (chunkPercentage) => {
                                        // 检查是否已被取消
                                        if (!ossAbortMultipartUploadObj.uploadId) {
                                            return
                                        }
                                        
                                        // 使用闭包确保获取正确的上传大小
                                        const currentUploaded = uploadedSize
                                        // 计算当前分片的已上传字节数
                                        const chunkUploaded = chunk.blob.size * chunkPercentage
                                        // 计算整体已上传字节数
                                        const currentTotal = currentUploaded + chunkUploaded
                                        // 更新整体进度
                                        const uploadProgress = Math.round((currentTotal / file.size) * 100)
                                        
                                        // 只在进度变化时调用回调，避免频繁更新
                                        if (uploadProgress > lastProgress) {
                                            lastProgress = uploadProgress
                                            progressCallback && progressCallback({
                                                percentage: uploadProgress,
                                                status: `上传中 ${uploadProgress}%`
                                            })
                                        }
                                    }
                                }
                            )
                            
                            // 检查是否已被取消
                            if (!ossAbortMultipartUploadObj.uploadId) {
                                reject(new Error('上传已被取消'))
                                return
                            }
                            
                            // 分片上传完成后，累加已上传大小
                            uploadedSize += chunk.blob.size
                            // 计算最终进度
                            const uploadProgress = Math.round((uploadedSize / file.size) * 100)
                            
                            // 确保进度更新
                            if (uploadProgress > lastProgress) {
                                lastProgress = uploadProgress
                                progressCallback && progressCallback({
                                    percentage: uploadProgress,
                                    status: `上传中 ${uploadProgress}%`,
                                })
                            } 
                            resolve({
                                number: actualIndex + 1,
                                etag: result.etag
                            })
                        } catch (error) {
                            console.error(`分片 ${actualIndex + 1} 上传失败:`, error)
                            reject(error)
                        }
                    })
                })
                uploadPromises.push(...batchPromises)
                // 等待当前批次完成后再继续
                await Promise.all(batchPromises)
            }
            
            // 检查是否已被取消
            if (!ossAbortMultipartUploadObj.uploadId) {
                throw new Error('上传已被取消')
            }
            
            // 4. 等待所有分片上传完成
            const parts = await Promise.all(uploadPromises)
            
            // 检查是否已被取消
            if (!ossAbortMultipartUploadObj.uploadId) {
                throw new Error('上传已被取消')
            }
            
            // 5. 合并分片
            await localOssClient.completeMultipartUpload(key, uploadId, parts)
            
            // 6. 上传完成
            ossAbortMultipartUploadObj = {}
            progressCallback && progressCallback({
                percentage: 100,
                status: '上传完成'
            })
            resolve({})
        } catch (error) {
            console.error('上传失败:', error)
            // 清空上传状态
            ossAbortMultipartUploadObj = {}
            if(error.code === 'InvalidDigest'){
               reject({code: 'InvalidDigest'})
            }else{
                reject(error)
            }
        }
    })

}

// 取消上传
export const ossAbortMultipartUpload = () => {
    return new Promise(async (resolve, reject) => {
        try {
            let { size, key, uploadId, ossConfig } = ossAbortMultipartUploadObj
            console.log('取消上传:', size, key, uploadId)
            if (size && key && uploadId) {
                try {
                    // 如果全局 ossClient 存在且有效，使用它；否则使用保存的配置创建新客户端
                    const client = ossClient || new OSS(ossConfig)
                    
                    // 调用 abortMultipartUpload 取消分片上传
                    const result = await client.abortMultipartUpload(key, uploadId)
                    console.log('取消上传成功:', result)
                    // 清空上传状态对象，这会触发正在上传的分片检测到取消
                    ossAbortMultipartUploadObj = {}
                    resolve(result)
                } catch (abortError) {
                    console.error('取消上传失败:', abortError)
                    // 即使取消失败，也要清空上传状态对象
                    ossAbortMultipartUploadObj = {}
                    reject(abortError)
                }
            } else {
                console.log('没有正在进行的上传任务')
                resolve()
            }
        } catch (error) {
            console.error('取消上传时发生错误:', error)
            // 发生错误时也清空上传状态
            ossAbortMultipartUploadObj = {}
            reject(error)
        }
    })
}  

//分片计算crc64
export const calculateLocalCRC64 = (file) =>{
    return new Promise(async (resolve, reject) => {
        const chunkSize = 2 * 1024 * 1024;        
        // 文件读取位置
        let offset = 0;

        const crc64 = await createCRC64();
        
        // 创建文件读取器
        const reader = new FileReader();
        
        // 读取文件的函数
        const readNextChunk = () => {
            const slice = file.slice(offset, offset + chunkSize);
            reader.readAsArrayBuffer(slice);
        };
    
        // 当一块读取完成时
        reader.onload = async (e) => {
            try {
                const arrayBuffer = e.target.result;
                // 使用crc库计算当前块的CRC64
                // 注意：crc64函数可以传入之前的crc值进行累加计算
                const uint8Array = new Uint8Array(arrayBuffer);
                // 使用 crc64.update 更新哈希值（累加计算）
                crc64.update(uint8Array);
                offset += arrayBuffer.byteLength;
                
                if (offset < file.size) {
                    // 还有数据，继续读取下一块
                    readNextChunk();
                } else {
                    // 计算完成，获取最终的哈希值
                    const crcHex = crc64.digest('hex');
                    // OSS 返回的是大写，转为大写以方便比对
                    resolve(BigInt('0x' + crcHex).toString());
                }
            } catch (error) {
                reject(error);
            }
        };
        
        reader.onerror = (error) => {
            reject(error);
        };
    
        // 开始读取第一块
        readNextChunk();
    });
}

//分割文件并计算每个分片的MD5
export const splitFileAndCalculateMd5=async (file,chunkSize) =>{
    const chunks = []
    const totalChunks = Math.ceil(file.size / chunkSize)
    
    for (let i = 0; i < totalChunks; i++) {
        const start = i * chunkSize
        const end = Math.min(start + chunkSize, file.size)
        const blob = file.slice(start, end)
        
        // 计算Base64编码的MD5值，用于HTTP Content-MD5头
        const md5Base64 = await calculateBlobMd5Base64(blob)
        
        chunks.push({
            blob,
            md5Base64,
            index: i
        })
    }
    
    return chunks
}

//计算单个Blob的MD5值
export const calculateBlobMd5=(blob)=> {
    return new Promise((resolve, reject) => {
        const spark = new SparkMD5.ArrayBuffer()
        const fileReader = new FileReader()
        
        fileReader.onload = (e) => {
            spark.append(e.target.result)
            resolve(spark.end())
        }
        
        fileReader.onerror = (error) => reject(error)
        fileReader.readAsArrayBuffer(blob)
    })
}

//计算单个Blob的Base64编码MD5值，用于HTTP Content-MD5头
export const calculateBlobMd5Base64=(blob)=> {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        
        fileReader.onload = (e) => {
            const arrayBuffer = e.target.result
            const md5 = CryptoJs.MD5(CryptoJs.lib.WordArray.create(arrayBuffer))
            const base64 = md5.toString(CryptoJs.enc.Base64)
            resolve(base64)
        }
        
        fileReader.onerror = (error) => reject(error)
        fileReader.readAsArrayBuffer(blob)
    })
}